import React from "react";

function AgentWarehouse() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 62 62"
    >
      <path
        fill="#d3a06c"
        d="M28 61H10a1 1 0 01-1-1V44a1 1 0 011-1h18a1 1 0 011 1v16a1 1 0 01-1 1zm28-38H46a1 1 0 01-1-1V6a1 1 0 011-1h10a1 1 0 011 1v16a1 1 0 01-1 1zm-12 0H34a1 1 0 01-1-1V6a1 1 0 011-1h10a1 1 0 011 1v16a1 1 0 01-1 1z"
        data-original="#d3a06c"
      ></path>
      <path
        fill="#ccd1d9"
        d="M61 23v4H35v-4h22z"
        data-original="#ccd1d9"
      ></path>
      <path
        fill="#b27946"
        d="M41 5v3c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1V5z"
        data-original="#b27946"
      ></path>
      <path
        fill="#d3a06c"
        d="M46 61H34a1 1 0 01-1-1V48a1 1 0 011-1h12a1 1 0 011 1v12a1 1 0 01-1 1zm14 0H48a1 1 0 01-1-1V48a1 1 0 011-1h12a1 1 0 011 1v12a1 1 0 01-1 1zm-6-14H42a1 1 0 01-1-1V34a1 1 0 011-1h12a1 1 0 011 1v12a1 1 0 01-1 1z"
        data-original="#d3a06c"
      ></path>
      <path
        fill="#b27946"
        d="M57 47v4c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1v-4h3zM53 5v3c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1V5zm-2 28v4c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1v-4zm-8 14v4c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1v-4h5z"
        data-original="#b27946"
      ></path>
      <path
        fill="#f0d0b4"
        d="M35 27.18c1.17.4 2 1.51 2 2.82 0 .83-.34 1.58-.88 2.12S34.83 33 34 33h-3.17c.11-.65.17-1.32.17-2v-4h3c.35 0 .69.06 1 .18z"
        data-original="#f0d0b4"
      ></path>
      <path
        fill="#656d78"
        d="M35 27.17v.01c-.31-.12-.65-.18-1-.18h-3v-6h4v6z"
        data-original="#656d78"
      ></path>
      <path
        fill="#ffeaa7"
        d="M35 19.17V21h-4v-1c0-.55-.45-1-1-1h-4l-.11-.84A30.46 30.46 0 0021 5h2c3.46.58 6.46 2.36 8.6 4.88.52.62.99 1.27 1.4 1.97 1.27 2.16 2 4.67 2 7.32z"
        data-original="#ffeaa7"
      ></path>
      <path
        fill="#f0d0b4"
        d="M33 48v4c0 .55-.45 1-1 1a2.996 2.996 0 01-2.12-5.12c.54-.54 1.29-.88 2.12-.88.55 0 1 .45 1 1zm-2-21v4c0 .68-.06 1.35-.17 2-.42 2.52-1.62 4.77-3.34 6.49A11.962 11.962 0 0119 43c-5.95 0-10.88-4.32-11.83-10-.11-.65-.17-1.32-.17-2v-9c0 .55.45 1 1 1h22c.55 0 1-.45 1-1z"
        data-original="#f0d0b4"
      ></path>
      <path
        fill="#ffc729"
        d="M31 21v1c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1h22c.55 0 1 .45 1 1z"
        data-original="#ffc729"
      ></path>
      <path
        fill="#fcd770"
        d="M25.89 18.16L26 19H12l.11-.84A30.46 30.46 0 0117 5h4a30.46 30.46 0 014.89 13.16z"
        data-original="#fcd770"
      ></path>
      <path
        fill="#b27946"
        d="M23 43v7l-4-2-4 2v-7h4z"
        data-original="#b27946"
      ></path>
      <path
        fill="#fcd770"
        d="M22.19 1.76L23 5h-8l.81-3.24c.11-.45.51-.76.97-.76h4.44c.46 0 .86.31.97.76z"
        data-original="#fcd770"
      ></path>
      <path
        fill="#ffeaa7"
        d="M15 5h2a30.46 30.46 0 00-4.89 13.16L12 19H8c-.55 0-1 .45-1 1v1H3v-1.83C3 12.15 8.08 6.15 15 5z"
        data-original="#ffeaa7"
      ></path>
      <path
        fill="#f0d0b4"
        d="M8.12 47.88A2.996 2.996 0 016 53c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1 .83 0 1.58.34 2.12.88zM7.17 33H4c-.83 0-1.58-.34-2.12-.88S1 30.83 1 30c0-1.31.83-2.42 2-2.82.31-.12.65-.18 1-.18h3v4c0 .68.06 1.35.17 2z"
        data-original="#f0d0b4"
      ></path>
      <path
        fill="#656d78"
        d="M7 22v5H4c-.35 0-.69.06-1 .18V21h4z"
        data-original="#656d78"
      ></path>
      <path
        d="M16 12h6v2h-6zm2.172 24H16v2h2.172a7.882 7.882 0 005.535-2.293l-1.414-1.414A5.868 5.868 0 0118.172 36zM24 56h2v2h-2zm-4 0h2v2h-2zm-4-26v-1c0-1.654-1.346-3-3-3s-3 1.346-3 3v1h2v-1a1 1 0 012 0v1zm12 0v-1c0-1.654-1.346-3-3-3s-3 1.346-3 3v1h2v-1a1 1 0 012 0v1z"
        data-original="#000000"
      ></path>
      <path
        d="M60 4v18h-2V6c0-1.103-.897-2-2-2H46c-.366 0-.705.106-1 .278A1.978 1.978 0 0044 4H34c-1.103 0-2 .897-2 2v2.825a15.296 15.296 0 00-8.181-4.672l-.659-2.637A1.997 1.997 0 0021.219 0h-4.438c-.92 0-1.718.623-1.94 1.516l-.659 2.637A15.298 15.298 0 002 19.165v7.391C.81 27.25 0 28.526 0 30c0 2.206 1.794 4 4 4h2.363a13.028 13.028 0 005.74 8H10c-1.103 0-2 .897-2 2v2.556A3.959 3.959 0 006 46c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2 .732 0 1.409-.212 2-.556V60c0 1.103.897 2 2 2h18c1.103 0 2-.897 2-2v-6.556A3.959 3.959 0 0032 54v6c0 1.103.897 2 2 2h12c.366 0 .705-.106 1-.278.295.172.634.278 1 .278h12c1.103 0 2-.897 2-2V4zM46 46h-4V34h2v3c0 1.103.897 2 2 2h4c1.103 0 2-.897 2-2v-3h2l.002 12H48zm-8 2h4v3h-4zm8-14h4v3h-4zm6 14h4v3h-4zm4-2V34c0-1.103-.897-2-2-2H42c-1.103 0-2 .897-2 2v12h-6c-.366 0-.705.106-1 .278A1.978 1.978 0 0032 46c-.732 0-1.409.212-2 .556V44c0-1.103-.897-2-2-2h-2.104a13.02 13.02 0 005.74-8H34c2.206 0 4-1.794 4-4 0-.732-.212-1.409-.556-2H60v18zm-40-2h6v4.382l-3-1.5-3 1.5zm4.446-38a29.69 29.69 0 014.413 12H13.141a29.69 29.69 0 014.413-12zM30 20l.002 2H8v-2zm2 11v-3h2c1.103 0 2 .897 2 2s-.897 2-2 2h-2.051A12.7 12.7 0 0032 31zm2-5h-2v-4h2zm26 0H36v-2h24zM50 6h2v2h-2zm-2 0v2c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2V6h2v16H46V6zM38 6h2v2h-2zm-4 0h2v2c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2V6h2v16h-8v-2.835c0-2.751-.726-5.343-2-7.591zm0 13.165V20h-2c0-1.103-.897-2-2-2h-3.118a31.733 31.733 0 00-4.078-12h.112A13.318 13.318 0 0134 19.165zM21.22 2l.503 2.011-5.443-.009L16.781 2zm-6.136 4h.112a31.715 31.715 0 00-4.078 12H8c-1.103 0-2 .897-2 2H4v-.835C4 12.635 8.656 7.11 15.084 6zM4 22h2v4H4zm0 10c-1.103 0-2-.897-2-2s.897-2 2-2h2v3c0 .338.025.669.051 1zm4-1v-7h22v7c0 6.065-4.935 11-11 11S8 37.065 8 31zM6 52v-4c1.103 0 2 .897 2 2s-.897 2-2 2zm4 8V44h4v7.618l5-2.5 5 2.5V44h4l.001 5.993L28 50l.001.007.001 9.993zm20-10c0-1.103.897-2 2-2v4c-1.103 0-2-.897-2-2zm4 10V48h2v3c0 1.103.897 2 2 2h4c1.103 0 2-.897 2-2v-3h2v12zm26.002 0H48V48h2v3c0 1.103.897 2 2 2h4c1.103 0 2-.897 2-2v-3h2z"
        data-original="#000000"
      ></path>
      <path
        d="M48 14h6v2h-6zm2 4h4v2h-4zm-14-4h6v2h-6zm2 4h4v2h-4z"
        data-original="#000000"
      ></path>
    </svg>
  );
}

export default AgentWarehouse;
